import React, { useState } from 'react';
import {
  ThemeProvider,
  CssBaseline,
  Box,
  Typography,
  Button,
  Stack,
  CircularProgress,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  TextField,
  FormLabel,
  Divider
} from '@mui/material';


export function SubmitTileForm({ onSuccess, onCancel }) {
  const [time, setTime] = useState('');
  const [battleKey, setbattleKey] = useState('');
  const [players, setPlayers] = useState('');
  const [course, setCourse] = useState('Emerald');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const res = await fetch('/.netlify/functions/submit-form', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        form: 'time',
        key: battleKey,
        time,
        players,
        course,
      }),
    });

    setLoading(false);

    if (!res.ok) {
      alert('Invalid key or failed submission');
      return;
    }

    const data = await res.json();
    console.log('✅ Submitted: new', data);

    if (onSuccess) onSuccess();
    setTime('');
    setPlayers('');
    setbattleKey('');
    setCourse('');
  };

  return (
    
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        p: 3,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        width: '320px',
      }}
    >
      <CssBaseline enableColorScheme />
      <Typography variant="h4" sx={{textAlign: "center"}}>
        🕒
      </Typography>
      <Typography variant="h3" sx={{textAlign: "center"}} gutterBottom>
        Propose Time
      </Typography>
      <FormLabel htmlFor="score" sx={{mb:-1}}>Tee Time</FormLabel>
      <TextField
        fullWidth
        id="time"
        placeholder="Tee Time"
        value={time}
        onChange={e => setTime(e.target.value)}
        required
        sx={{
          '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'black',
          },
          '& .MuiInputLabel-root.Mui-focused': {
            color: 'black',
          },
        }}
      />
      <FormLabel htmlFor="score" sx={{mb:-1}}>Players</FormLabel>
      <TextField
        fullWidth
        id="players"
        value={players}
        placeholder="Ex. 8"
        onChange={e => setPlayers(e.target.value)}
        required
        sx={{
          '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'black',
          },
          '& .MuiInputLabel-root.Mui-focused': {
            color: 'black',
          },
        }}
      />
      <FormLabel htmlFor="battle-key" sx={{mb:-1}}>Battle Key</FormLabel>
      <TextField
        fullWidth
        name="battle key"
        id="battle-key"
        value={battleKey}
        placeholder="Ex. bigidiot2"
        type="text"
        onChange={e => setbattleKey(e.target.value)}
        required
        sx={{
          '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'black',
          },
          '& .MuiInputLabel-root.Mui-focused': {
            color: 'black',
          },
        }}
      />
      <FormLabel htmlFor="battle-key" sx={{mb:-1}}>Course</FormLabel>
      <Select
        id="course"
        value={course}
        label="Course"
        placeholder="Course"
        variant='outlined'
        onChange={e => setCourse(e.target.value)}
      >
        <MenuItem value="emerald">Emerald</MenuItem>
        <MenuItem value="muni">Muni</MenuItem>
      </Select>

      <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ mt: 1 }}>
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
        <Button fullwidth variant="contained" type="submit">
          {loading ? <CircularProgress size={16} color="inherit" /> : 'Submit'}
        </Button>
      </Stack>
    </Box>
  );
}